export default __webpack_public_path__ + "static/LTZ_MOBILE-4bd7379735578f381016ee50a6c94d61.jpg";